import * as React from "react";
import {cx} from "emotion";
import {cs} from "@Common/react/chain-services";

import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";
import {faCheck, faXmark} from "@fortawesome/free-solid-svg-icons";
import {formatMoney} from "@Common/ui-components/language/format-money";
import "./subscribe-card.scss";
import {PLAN_TYPE} from "../../subscriptions-details";

export const SubscribeCard = ({plan, selectedPlanId, subscriptionPlans}) => cs(
    ({}) => (
        <div className="subscribe-card subscribe-card-sc1">
            <div className="plan-wrapper" key={plan.idChargebeePricePoint}>
                <div
                    className={cx("plan",{selected: selectedPlanId.value === plan.idChargebeePricePoint})}
                    xd-qa-type="card"
                    xd-qa-name={plan.idChargebeePricePoint}
                    onClick={() => selectedPlanId.onChange(plan.idChargebeePricePoint)}
                >
                    <div className={cx("top", {selected: selectedPlanId.value === plan.idChargebeePricePoint})}>
                        <div>{plan.name}</div>
                        <div>Subscription</div>
                    </div>
                    <div className={cx("bottom", {selected: selectedPlanId.value === plan.idChargebeePricePoint, "best-value": plan.idPlanType === PLAN_TYPE.YEAR})}>
                        <div className="benefits-list">
                        {subscriptionPlans.value && subscriptionPlans.value.availableBenefits.map((benefit, index) =>
                            // TODO: remove bandaid solution to keep AI-assisted Property Descriptions from showing up in the benefits list
                            benefit !== "AI-assisted Property Descriptions" &&
                            <div key={index} className={cx("benefit", {odd: index % 2 === 1})}>{plan.benefits.includes(benefit) ? (
                                <div className="circle">
                                    <div className="check"><FontAwesomeIcon className={"icon"} icon={faCheck} xd-qa-type="icon" xd-qa-name="Check"/></div>
                                </div>
                            ) : (
                                <div className="cross"><FontAwesomeIcon className={"icon"} icon={faXmark} xd-qa-type="icon" xd-qa-name="Check"/></div>
                            )}</div>
                        )}
                        </div>
                        <div className="price">
                            {formatMoney((plan.priceCents / 100), {alwaysShowDollarSymbol: true})}{"/" + (plan.idPlanType === PLAN_TYPE.MONTH ? "mo" : "yr")}
                        </div>
                        <div className="best-value">
                            {plan.idPlanType === PLAN_TYPE.YEAR ? "BEST VALUE!" : ""}
                        </div>
                        <div className="select-button">
                            {selectedPlanId.value === plan.idChargebeePricePoint ? "SELECTED" : "SELECT PLAN"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ),
);
